import React, { Suspense, useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { NavBar, Result, Skeleton } from 'antd-mobile'
import './index.scss'
//const ua = navigator.userAgent.toLowerCase()
const ua = 'micromessenger'
export default function Api() {
  const { pathname } = useLocation()
  const [title,setTitle] = useState(null)
  useEffect(() => {
    if(pathname.includes('add')){
      setTitle('预处理申请')
    }else if(pathname.includes('open')){
      setTitle('开卡')
    }else if(pathname.includes('detail')){
      setTitle('详情')
    }else if(pathname.includes('evidence')){
      setTitle('补件')
    }else if(pathname.includes('esign')){
      setTitle('客户列表')
    }
  },[pathname])
  return (
    <div className='esign'>  
      {
        ua.includes('micromessenger') ? (
          <Suspense fallback={
              <>
                <Skeleton.Title animated />
                <Skeleton.Paragraph lineCount={5} animated />
              </>
            }
          >
            <NavBar className='esign-navbar' backArrow={null}>{title}</NavBar>
            <Outlet/>
          </Suspense>
        ) : (
          <Result
            status='warning'
            title='警告'
            description='请在微信内打开页面'
          />
        )
      }
    </div>
  )
}